<template>
    <div class="has-background-grey-lighter">
        <app-animation :animation="animation" :loop="true" />
        <p
            v-t="'App.error_fetch_project'"
            class="has-text-centered has-text-black title is-overlay pt-6"
        ></p>
    </div>
</template>

<script>
import AppAnimation from '@/components/AppAnimation';
export default {
    components: {
        AppAnimation,
    },
    props: {
        message: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            animation: require('@/assets/animations/lock.json'),
        };
    },
};
</script>

<style></style>
